import { render, staticRenderFns } from "./editDistrict.vue?vue&type=template&id=f16a57d0&scoped=true&"
import script from "./editDistrict.vue?vue&type=script&lang=js&"
export * from "./editDistrict.vue?vue&type=script&lang=js&"
import style0 from "./editDistrict.vue?vue&type=style&index=0&id=f16a57d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16a57d0",
  null
  
)

export default component.exports